import { type ReactNode } from 'react'
import { Switch } from '@mantine/core'

type Props = {
  checked: boolean
  description: string
  label: string
  onChange: (checked: boolean) => void
}

export const ToggleRow = ({ checked, description, label, onChange }: Props): ReactNode => {
  return (
    <Switch
      checked={checked}
      classNames={{
        root: 'w-full',
        body: 'w-full items-center justify-between',
        labelWrapper: 'flex-1',
        label: 'font-medium',
      }}
      description={description}
      label={label}
      labelPosition='left'
      py='xs'
      onChange={(event) => onChange(event.currentTarget.checked)}
    />
  )
}
